import { useRouter } from '@application/utils';
import type { ProGetWhatsappInfoQuery } from '@gql/graphql';
import type { WhatsappProDetails } from '@presentation/components';
import { PLACEHOLDER_IMAGE_USER } from '@presentation/constants';
import { useMemo } from 'react';

type Pro = NonNullable<ProGetWhatsappInfoQuery['searchProfessionals']>['professionals'][number];

export const useFormatPro = (pro: Pro | undefined) => {
  const { language } = useRouter();

  const formattedPro: WhatsappProDetails | undefined = useMemo(() => {
    if (!pro) return;

    const translation = pro?.translations.find((entry) => entry.language === language);

    return {
      title: translation?.title ? translation?.title : pro?.translations[0]?.title,
      avatar: pro.imgs?.[0]?.small ?? PLACEHOLDER_IMAGE_USER,
      type: pro.type,
    } as WhatsappProDetails;
  }, [language, pro]);

  return {
    formattedPro,
  };
};
